import apiClient from './client'
import type { CodingBucketCollectionSource } from './named-collections'

export interface CodingBucketSourceLink {
  kind: string
  label: string
  path: string
  params: Record<string, unknown>
  collection_source?: CodingBucketCollectionSource | null
  default_collection_name?: string | null
}

export interface CodingBucketCount {
  id: string
  label: string
  description: string
  count: number
  ai_suggested?: number | null
  human_confirmed?: number | null
  source_links: CodingBucketSourceLink[]
}

export interface RfpCodingBucket extends CodingBucketCount {
  ask_id: string
  source_label: string | null
  title: string
  verification_counts: Record<string, number>
  max_confidence: number | null
}

export interface CodingBucketsSummary {
  matter_id: string
  generated_at: string
  privilege: CodingBucketCount
  hot_tags: CodingBucketCount[]
  rfp_requests: RfpCodingBucket[]
  needs_review: CodingBucketCount
}

export const codingBucketsApi = {
  async getSummary(matterId: string): Promise<CodingBucketsSummary> {
    const { data } = await apiClient.get<CodingBucketsSummary>(
      `/matters/${matterId}/coding-buckets`
    )
    return data
  },
}
